export default __webpack_public_path__ + "static/media/icon.200ccc34.svg";